var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.headerVisible,
          expression: "headerVisible"
        }
      ],
      ref: "HeaderBox",
      staticClass: "HeaderBox",
      class: [
        _vm.headerBoxRouteClass,
        { "HeaderBox--chrome-hidden": !_vm.bol && _vm.aiAssistantVisible },
        { "HeaderBox--ai-assistant-open": _vm.aiAssistantVisible }
      ],
      attrs: { id: "HeaderBox" }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.bol,
              expression: "bol"
            }
          ],
          staticClass: "header-box-chrome"
        },
        [
          _c("div", { staticClass: "ward" }, [
            _c("div", { staticClass: "left" }, [
              _c(
                "div",
                {
                  staticClass: "logo_img cursor",
                  on: {
                    click: function($event) {
                      return _vm.$router.push("/")
                    }
                  }
                },
                [
                  !_vm.isScroll
                    ? _c("img", {
                        attrs: { src: "https://img.webloom.cn/img/sylogo1.png" }
                      })
                    : _c("img", {
                        attrs: {
                          src: "https://img.webloom.cn/img/sylogo2.png",
                          alt: ""
                        }
                      })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "list" },
                _vm._l(_vm.list, function(o, index) {
                  return _c(
                    "div",
                    {
                      key: o.title.zh,
                      ref: "a" + index,
                      refInFor: true,
                      staticClass: "item cursor fontColor",
                      on: {
                        click: function($event) {
                          return _vm.navBtn(index, o.title.zh)
                        }
                      }
                    },
                    [
                      o.title.zh == "项目活动"
                        ? _c(
                            "div",
                            [
                              _c("img", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.dropBol,
                                    expression: "dropBol"
                                  }
                                ],
                                staticClass: "upTriangle",
                                attrs: {
                                  src: "//img.webloom.cn/img/up.png",
                                  alt: ""
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "season-drop",
                                {
                                  attrs: {
                                    projectList: _vm.projectList,
                                    title: o.title[_vm.lang]
                                  },
                                  on: { bol: _vm.bolChange }
                                },
                                [
                                  _c("template", { slot: "title" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "nav-project-title",
                                        style: _vm.isScroll
                                          ? "color: #030A17;"
                                          : ""
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(o.title[_vm.lang]) +
                                            "\n                  "
                                        ),
                                        _c("img", {
                                          staticClass: "nav-project-arrow",
                                          attrs: {
                                            src: _vm.isScroll
                                              ? "https://img.webloom.cn/Img/xiangmuxialahei.png"
                                              : "https://img.webloom.cn/Img/xiangmuxialabai.png",
                                            alt: ""
                                          }
                                        })
                                      ]
                                    )
                                  ])
                                ],
                                2
                              )
                            ],
                            1
                          )
                        : o.title.zh == "活动广场"
                        ? _c(
                            "div",
                            [
                              _c(
                                "plaza-drop",
                                {
                                  style: _vm.isScroll ? "color: #030A17;" : "",
                                  attrs: { title: o.title[_vm.lang] }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      class: {
                                        selectItem: _vm.itemIndex == index
                                      }
                                    },
                                    [_vm._v(_vm._s(o.title[_vm.lang]))]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _c(
                            "span",
                            {
                              staticClass: "nav-item-label",
                              style: _vm.isScroll ? "color: #030A17;" : ""
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(o.title[_vm.lang]) +
                                  "\n            "
                              ),
                              (o.title.zh == "首页" &&
                                _vm.routeName == "Index") ||
                              (o.title.zh == "发现" &&
                                _vm.routeName == "DiscoverHome")
                                ? _c("img", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.isScroll,
                                        expression: "!isScroll"
                                      }
                                    ],
                                    staticClass: "bottomLine",
                                    attrs: {
                                      src:
                                        "https://img.webloom.cn/img/sydaohanglanbg.png",
                                      alt: ""
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              (o.title.zh == "首页" &&
                                _vm.routeName == "Index") ||
                              (o.title.zh == "发现" &&
                                _vm.routeName == "DiscoverHome")
                                ? _c("img", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.isScroll,
                                        expression: "isScroll"
                                      }
                                    ],
                                    staticClass: "bottomLine",
                                    attrs: {
                                      src:
                                        "https://img.webloom.cn/img/sydaohanglanbglan.png",
                                      alt: ""
                                    }
                                  })
                                : _vm._e()
                            ]
                          )
                    ]
                  )
                }),
                0
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "right" },
              [
                _c("div", { staticClass: "iconBox" }, [
                  _c(
                    "button",
                    {
                      staticClass: "ai-entry-pill",
                      class: { "ai-entry-pill--locale-zh": _vm.lang === "zh" },
                      attrs: {
                        type: "button",
                        "aria-label": _vm.$t("aiStudyBuddy.title")
                      },
                      on: { click: _vm.openAiAssistantFromHeader }
                    },
                    [
                      _c("img", {
                        staticClass: "ai-entry-pill__img",
                        attrs: {
                          src: _vm.aiAssistantEntryBannerSrc,
                          alt: "",
                          draggable: "false"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "ai-entry-pill__fake-input",
                          attrs: { "aria-hidden": "true" }
                        },
                        [
                          _vm._v(
                            _vm._s("|  " + _vm.aiAssistantEntryPlaceholder)
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "ai-entry-pill__tail-icon",
                        attrs: {
                          src: "https://img.webloom.cn/Img/aisousuoIcon.webp",
                          alt: "",
                          draggable: "false"
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _vm.EventPlazaBtn
                    ? _c(
                        "div",
                        {
                          staticClass: "activity cursor",
                          on: { click: _vm.activityBtn }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: _vm.isScroll
                                ? "https://img.webloom.cn/img/xiaoxihei.png"
                                : "https://img.webloom.cn/img/xiaoxibai.png",
                              alt: ""
                            }
                          }),
                          _vm._v(" "),
                          +_vm.unRead > 0
                            ? _c("div", { staticClass: "num" }, [
                                _vm._v(
                                  _vm._s(+_vm.unRead > 99 ? "99" : _vm.unRead)
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm.isLogin && _vm.userType == 1
                  ? _c(
                      "div",
                      {
                        staticClass: "coachBtn cursor",
                        style: _vm.isScroll
                          ? "border: 1px solid #296BFF; color: #296BFF;"
                          : "",
                        on: { click: _vm.goCoach }
                      },
                      [_vm._v(_vm._s(_vm.$t("tabs.toCoach")))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("a", {
                  ref: "coachBtna",
                  staticClass: "none",
                  attrs: { href: _vm.coachHref, target: "_blank" }
                }),
                _vm._v(" "),
                _vm.isLogin
                  ? _c(
                      "div",
                      { staticClass: "user_icon cursor" },
                      [
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              "popper-class": "headerPopover",
                              placement: "bottom",
                              trigger: "hover"
                            },
                            on: { show: _vm.headerPopoverShow }
                          },
                          [
                            _c("div", { staticClass: "popoverCent" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "contentItem",
                                  on: {
                                    click: function($event) {
                                      return _vm.handleCommand("MyActivities")
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "itemIn",
                                      on: {
                                        mouseenter: _vm.contentItemMouseover
                                      }
                                    },
                                    [
                                      _c("div"),
                                      _vm._v(" "),
                                      _c("img", {
                                        staticClass: "itemInIcon",
                                        attrs: {
                                          src:
                                            "https://img.webloom.cn/img/dropdownicon1.png",
                                          alt: ""
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("img", {
                                        staticClass: "itemInIcon1",
                                        attrs: {
                                          src:
                                            "https://img.webloom.cn/img/dropdownicon1act.png",
                                          alt: ""
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          class:
                                            _vm.$i18n.locale !== "zh"
                                              ? "itemInTxtEn"
                                              : "itemInTxt"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("mine.activity"))
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "contentItem",
                                  on: {
                                    click: function($event) {
                                      return _vm.handleCommand("MySociety")
                                    }
                                  }
                                },
                                [
                                  _c("div", { staticClass: "itemIn" }, [
                                    _c("img", {
                                      staticClass: "itemInIcon",
                                      attrs: {
                                        src:
                                          "https://img.webloom.cn/img/dropdownicon2.png",
                                        alt: ""
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("img", {
                                      staticClass: "itemInIcon1",
                                      attrs: {
                                        src:
                                          "https://img.webloom.cn/img/dropdownicon2act.png",
                                        alt: ""
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        class:
                                          _vm.$i18n.locale !== "zh"
                                            ? "itemInTxtEn"
                                            : "itemInTxt"
                                      },
                                      [_vm._v(_vm._s(_vm.$t("mine.society")))]
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "contentItem",
                                  on: {
                                    click: function($event) {
                                      return _vm.handleCommand("battleCenter")
                                    }
                                  }
                                },
                                [
                                  _c("div", { staticClass: "itemIn" }, [
                                    _c("img", {
                                      staticClass: "itemInIcon",
                                      attrs: {
                                        src:
                                          "https://img.webloom.cn/img/dropdownicon3.png",
                                        alt: ""
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("img", {
                                      staticClass: "itemInIcon1",
                                      attrs: {
                                        src:
                                          "https://img.webloom.cn/img/dropdownicon3act.png",
                                        alt: ""
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        class:
                                          _vm.$i18n.locale !== "zh"
                                            ? "itemInTxtEn"
                                            : "itemInTxt"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("mine.battleCenter"))
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "contentItem",
                                  on: {
                                    click: function($event) {
                                      return _vm.handleCommand("MyOrder")
                                    }
                                  }
                                },
                                [
                                  _c("div", { staticClass: "itemIn" }, [
                                    _c("img", {
                                      staticClass: "itemInIcon",
                                      attrs: {
                                        src:
                                          "https://img.webloom.cn/img/dropdownicon4.png",
                                        alt: ""
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("img", {
                                      staticClass: "itemInIcon1",
                                      attrs: {
                                        src:
                                          "https://img.webloom.cn/img/dropdownicon4act.png",
                                        alt: ""
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        class:
                                          _vm.$i18n.locale !== "zh"
                                            ? "itemInTxtEn"
                                            : "itemInTxt"
                                      },
                                      [_vm._v(_vm._s(_vm.$t("mine.orders")))]
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "contentItem",
                                  on: {
                                    click: function($event) {
                                      return _vm.handleCommand("MessageUs")
                                    }
                                  }
                                },
                                [
                                  _c("div", { staticClass: "itemIn" }, [
                                    _c("img", {
                                      staticClass: "itemInIcon",
                                      attrs: {
                                        src:
                                          "https://img.webloom.cn/Img/gondan0.png",
                                        alt: ""
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("img", {
                                      staticClass: "itemInIcon1",
                                      attrs: {
                                        src:
                                          "https://img.webloom.cn/Img/gondan1.png",
                                        alt: ""
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        class:
                                          _vm.$i18n.locale !== "zh"
                                            ? "itemInTxtEn"
                                            : "itemInTxt"
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(_vm.$t("mine.messageUs")) +
                                            "\n                    "
                                        ),
                                        _vm.TicketNum > 0
                                          ? _c(
                                              "div",
                                              { staticClass: "TicketNum" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.TicketNum > 99
                                                      ? "99+"
                                                      : _vm.TicketNum
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "contentItem",
                                  on: {
                                    click: function($event) {
                                      return _vm.handleCommand("setting")
                                    }
                                  }
                                },
                                [
                                  _c("div", { staticClass: "itemIn" }, [
                                    _c("img", {
                                      staticClass: "itemInIcon",
                                      attrs: {
                                        src:
                                          "https://img.webloom.cn/img/dropdownicon5.png",
                                        alt: ""
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("img", {
                                      staticClass: "itemInIcon1",
                                      attrs: {
                                        src:
                                          "https://img.webloom.cn/img/dropdownicon5act.png",
                                        alt: ""
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        class:
                                          _vm.$i18n.locale !== "zh"
                                            ? "itemInTxtEn"
                                            : "itemInTxt"
                                      },
                                      [_vm._v(_vm._s(_vm.$t("mine.setting")))]
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "contentItem exitBox",
                                  on: {
                                    click: function($event) {
                                      return _vm.handleCommand("logout")
                                    }
                                  }
                                },
                                [
                                  _c("div", { staticClass: "itemIn" }, [
                                    _c("img", {
                                      staticClass: "itemInIcon",
                                      attrs: {
                                        src:
                                          "https://img.webloom.cn/img/dropdownicon6.png",
                                        alt: ""
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("img", {
                                      staticClass: "itemInIcon1",
                                      attrs: {
                                        src:
                                          "https://img.webloom.cn/img/dropdownicon6act.png",
                                        alt: ""
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        class:
                                          _vm.$i18n.locale !== "zh"
                                            ? "itemInTxtEn exit"
                                            : "itemInTxt exit"
                                      },
                                      [_vm._v(_vm._s(_vm.$t("mine.quite")))]
                                    )
                                  ])
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "img_container",
                                attrs: { slot: "reference" },
                                on: { click: _vm.checkStatu },
                                slot: "reference"
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: _vm.hearderImg,
                                    onerror:
                                      "this.src='//img.webloom.cn/img/logo/default-user.png';this.onerror=null"
                                  }
                                })
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : [
                      _vm.isScroll
                        ? _c(
                            "div",
                            {
                              staticClass: "btnBlue cursor",
                              on: { click: _vm.handleLogin }
                            },
                            [_vm._v(_vm._s(_vm.$t("tabs.loginOrRes")))]
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "btn cursor",
                              style: _vm.isScroll
                                ? "border: 1px solid #296BFF; color: #296BFF;"
                                : "border: 1px solid #fff;",
                              on: { click: _vm.handleLogin }
                            },
                            [_vm._v(_vm._s(_vm.$t("tabs.loginOrRes")))]
                          )
                    ],
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "myActivit cursor",
                    style: _vm.isScroll
                      ? "border: 1px solid #296BFF; color: #296BFF;"
                      : "",
                    on: {
                      click: function($event) {
                        return _vm.handleCommand("MyActivities")
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("mine.activity")))]
                )
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "change-lang cursor",
              style: _vm.isScroll ? "" : "border-color: #fff",
              on: { click: _vm.changeLang }
            },
            [
              _vm.isScroll
                ? [
                    _c(
                      "span",
                      { class: { active: _vm.$i18n.locale == "en" } },
                      [_vm._v("EN")]
                    ),
                    _vm._v("/"),
                    _c(
                      "span",
                      { class: { active: _vm.$i18n.locale != "en" } },
                      [_vm._v("中")]
                    )
                  ]
                : [
                    _c(
                      "span",
                      {
                        class: { active: _vm.$i18n.locale == "en" },
                        style: _vm.isScroll
                          ? "#D7D7D7FF"
                          : _vm.$i18n.locale !== "en"
                          ? "color: #fff; opacity:0.5"
                          : "color: #fff; opacity:1"
                      },
                      [_vm._v("EN")]
                    ),
                    _c(
                      "span",
                      { style: _vm.isScroll ? "#D7D7D7FF" : "color: #fff" },
                      [_vm._v("/")]
                    ),
                    _c(
                      "span",
                      {
                        class: { active: _vm.$i18n.locale == "en" },
                        style: _vm.isScroll
                          ? "#D7D7D7FF"
                          : _vm.$i18n.locale == "en"
                          ? "color: #fff; opacity:0.5"
                          : "color: #fff; opacity:1"
                      },
                      [_vm._v("中")]
                    )
                  ]
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "ai-assistant-fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.aiAssistantVisible,
                expression: "aiAssistantVisible"
              }
            ],
            ref: "aiAssistantPanel",
            staticClass: "ai-assistant-panel",
            class: {
              "ai-assistant-panel--compact": _vm.aiAssistantCompact,
              "ai-assistant-panel--compact-nav-open":
                _vm.aiAssistantCompact && _vm.aiCompactSidebarOpen,
              "ai-assistant-panel--locale-en": _vm.$i18n.locale === "en",
              "ai-assistant-panel--bloom-route": !_vm.bol
            },
            attrs: {
              tabindex: "-1",
              role: "dialog",
              "aria-modal": "true",
              "aria-label": _vm.$t("aiStudyBuddy.title")
            },
            on: {
              keydown: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "esc", 27, $event.key, [
                    "Esc",
                    "Escape"
                  ])
                ) {
                  return null
                }
                $event.stopPropagation()
                return _vm.onAiAssistantEsc.apply(null, arguments)
              }
            }
          },
          [
            _c("div", { staticClass: "ai-assistant-panel-body" }, [
              _c(
                "aside",
                {
                  ref: "aiAssistantSidebar",
                  staticClass: "ai-assistant-sidebar"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "ai-side-item",
                      class: { "is-active": _vm.aiSidebarTab === "newChat" },
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.setAiSidebarTab("newChat")
                        }
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "ai-side-icon",
                        attrs: {
                          src: "https://img.webloom.cn/Img/aiNewChat.webp",
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ai-side-label" }, [
                        _vm._v(_vm._s(_vm.$t("aiStudyBuddy.sidebarNewChat")))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "ai-side-item",
                      class: { "is-active": _vm.aiSidebarTab === "recommend" },
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.setAiSidebarTab("recommend")
                        }
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "ai-side-icon",
                        attrs: {
                          src:
                            "https://img.webloom.cn/Img/aiRecommendation.webp",
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ai-side-label" }, [
                        _vm._v(_vm._s(_vm.$t("aiStudyBuddy.sidebarRecommend")))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "ai-side-item",
                      class: { "is-active": _vm.aiSidebarTab === "topic" },
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.setAiSidebarTab("topic")
                        }
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "ai-side-icon",
                        attrs: {
                          src: "https://img.webloom.cn/Img/aiTopic.webp",
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ai-side-label" }, [
                        _vm._v(_vm._s(_vm.$t("aiStudyBuddy.sidebarTopic")))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "ai-sidebar-history-block" }, [
                    _c(
                      "button",
                      {
                        staticClass: "ai-side-item ai-side-item--history",
                        attrs: {
                          type: "button",
                          "aria-expanded":
                            _vm.aiChatHistory.length &&
                            _vm.aiHistorySidebarExpanded
                              ? "true"
                              : "false"
                        },
                        on: { click: _vm.toggleAiHistorySidebarExpand }
                      },
                      [
                        _c("img", {
                          staticClass: "ai-side-icon",
                          attrs: {
                            src: "https://img.webloom.cn/Img/aiHistory.webp",
                            alt: ""
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "ai-side-label" }, [
                          _vm._v(_vm._s(_vm.$t("aiStudyBuddy.sidebarHistory")))
                        ]),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "ai-side-chevron-img",
                          class: {
                            "ai-side-chevron-img--rotated": !_vm.aiHistorySidebarExpanded
                          },
                          attrs: {
                            src: "https://img.webloom.cn/Img/ai-dorp.webp",
                            alt: "",
                            width: "13",
                            height: "8"
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.toggleAiHistorySidebarExpand.apply(
                                null,
                                arguments
                              )
                            }
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.aiChatHistory.length &&
                              _vm.aiHistorySidebarExpanded,
                            expression:
                              "aiChatHistory.length && aiHistorySidebarExpanded"
                          }
                        ],
                        staticClass: "ai-sidebar-history-list"
                      },
                      [
                        _c(
                          "ul",
                          { staticClass: "ai-sidebar-history-items" },
                          _vm._l(_vm.aiChatHistory, function(item) {
                            return _c(
                              "li",
                              {
                                key: item.fromServer
                                  ? "s-" + item.aiDialogueId
                                  : item.id,
                                staticClass: "ai-sidebar-history-li"
                              },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      "popper-class":
                                        "ai-sidebar-history-tooltip",
                                      content: _vm.historyItemTooltipText(item),
                                      placement: "right",
                                      "open-delay": 200
                                    }
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "ai-sidebar-history-link",
                                        class: {
                                          "is-selected":
                                            item.id === _vm.aiSelectedHistoryId
                                        },
                                        attrs: { type: "button" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.selectAiHistoryItem(item)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(item.preview) +
                                            "\n                  "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          }),
                          0
                        )
                      ]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.aiAssistantCompact && _vm.aiCompactSidebarOpen,
                    expression: "aiAssistantCompact && aiCompactSidebarOpen"
                  }
                ],
                staticClass: "ai-compact-sidebar-backdrop",
                attrs: { "aria-hidden": "true" },
                on: { click: _vm.closeAiCompactNav }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "ai-assistant-main" }, [
                _c(
                  "header",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.aiAssistantCompact,
                        expression: "aiAssistantCompact"
                      }
                    ],
                    staticClass: "ai-compact-header"
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "ai-compact-menu",
                        attrs: {
                          type: "button",
                          "aria-label": _vm.aiCompactSidebarOpen
                            ? _vm.$t("aiStudyBuddy.ariaCloseMenu")
                            : _vm.$t("aiStudyBuddy.ariaOpenMenu"),
                          "aria-expanded": _vm.aiCompactSidebarOpen
                            ? "true"
                            : "false"
                        },
                        on: { click: _vm.toggleAiCompactNav }
                      },
                      [
                        _c("img", {
                          staticClass: "ai-compact-menu-icon",
                          attrs: {
                            src: "https://img.webloom.cn/Img/aiMemu.png",
                            alt: "",
                            width: "20",
                            height: "16"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "ai-compact-title" }, [
                      _vm._v(_vm._s(_vm.$t("aiStudyBuddy.title")))
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "ai-compact-close",
                        attrs: {
                          type: "button",
                          "aria-label": _vm.$t("aiStudyBuddy.ariaClose")
                        },
                        on: { click: _vm.closeAiAssistant }
                      },
                      [
                        _c("span", { attrs: { "aria-hidden": "true" } }, [
                          _vm._v("×")
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.aiAssistantCompact,
                        expression: "!aiAssistantCompact"
                      }
                    ],
                    staticClass: "ai-assistant-close",
                    attrs: {
                      type: "button",
                      "aria-label": _vm.$t("aiStudyBuddy.ariaClose")
                    },
                    on: { click: _vm.closeAiAssistant }
                  },
                  [
                    _c("img", {
                      staticClass: "ai-assistant-close-img",
                      attrs: {
                        src: "https://img.webloom.cn/Img/aiCLOSE.png",
                        alt: "",
                        "aria-hidden": "true"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "ai-main-column" }, [
                  _c(
                    "div",
                    {
                      ref: "aiChatScroll",
                      staticClass: "ai-chat-scroll",
                      on: { scroll: _vm.onAiChatScroll }
                    },
                    [
                      _vm.aiSidebarTab === "newChat"
                        ? [
                            _c("div", { staticClass: "ai-newchat-wrap" }, [
                              _vm.aiAssistantCompact
                                ? _c("p", { staticClass: "ai-newchat-greet" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t("aiStudyBuddy.compactGreet")
                                        ) +
                                        "\n              "
                                    )
                                  ])
                                : _c("p", { staticClass: "ai-newchat-greet" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("aiStudyBuddy.newChatGreet")
                                      )
                                    )
                                  ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "ai-newchat-cards" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "ai-feature-card ai-feature-card--recommend",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        return _vm.setAiSidebarTab("recommend")
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "ai-feature-card-text" },
                                      [
                                        _c(
                                          "h3",
                                          {
                                            staticClass: "ai-feature-card-title"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "aiStudyBuddy.cardRecommendTitle"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          {
                                            staticClass: "ai-feature-card-desc"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "aiStudyBuddy.cardRecommendDesc"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "ai-feature-card ai-feature-card--topic",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        return _vm.setAiSidebarTab("topic")
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "ai-feature-card-text" },
                                      [
                                        _c(
                                          "h3",
                                          {
                                            staticClass: "ai-feature-card-title"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "aiStudyBuddy.cardTopicTitle"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          {
                                            staticClass: "ai-feature-card-desc"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "aiStudyBuddy.cardTopicDesc"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ])
                          ]
                        : _vm.aiSidebarTab === "recommend"
                        ? [
                            _c(
                              "p",
                              { staticClass: "ai-msg ai-msg--assistant" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("aiStudyBuddy.recommendIntro")
                                    ) +
                                    "\n              "
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("aiStudyBuddy.recommendQuestion")
                                    ) +
                                    "\n            "
                                )
                              ]
                            )
                          ]
                        : _vm.aiSidebarTab === "topic"
                        ? [
                            _c(
                              "p",
                              { staticClass: "ai-msg ai-msg--assistant" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("aiStudyBuddy.topicIntro")) +
                                    "\n              "
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("aiStudyBuddy.topicQuestion")
                                    ) +
                                    "\n            "
                                )
                              ]
                            )
                          ]
                        : _vm.aiSidebarTab === "history"
                        ? [
                            _vm.selectedHistoryItem ||
                            _vm.aiShowEntryBootstrapChat
                              ? [
                                  _vm.aiShowEntryBootstrapChat ||
                                  (_vm.selectedHistoryItem &&
                                    _vm.selectedHistoryItem.fromServer)
                                    ? [
                                        _vm.aiHistoryMsgList.length
                                          ? _vm._l(
                                              _vm.aiHistoryMsgRowsForView,
                                              function(row) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key:
                                                      row.aiDialogueChatRecordId,
                                                    staticClass:
                                                      "ai-history-msg-turn"
                                                  },
                                                  [
                                                    row.userReq
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "ai-msg ai-msg--user"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                row.userReq
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "ai-answer-slot"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  row.answerThinkingVisible,
                                                                expression:
                                                                  "row.answerThinkingVisible"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "ai-answer-wait-loading",
                                                            attrs: {
                                                              "aria-live":
                                                                "polite"
                                                            }
                                                          },
                                                          [
                                                            _c("img", {
                                                              staticClass:
                                                                "ai-answer-wait-loading__icon",
                                                              attrs: {
                                                                src:
                                                                  "https://img.webloom.cn/Img/chatLodding.gif",
                                                                width: "20",
                                                                height: "20",
                                                                alt: ""
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "ai-answer-wait-loading__text"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "aiStudyBuddy.thinkingBase"
                                                                      )
                                                                    )
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "ai-answer-wait-loading__dots"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.aiThinkingDotsSuffix
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value: !row.answerThinkingVisible,
                                                                expression:
                                                                  "!row.answerThinkingVisible"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "ai-answer-below-thinking"
                                                          },
                                                          [
                                                            String(
                                                              row.im750ErrorTip ||
                                                                ""
                                                            ).trim()
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "ai-im750-error-tip",
                                                                    attrs: {
                                                                      role:
                                                                        "alert"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        row.im750ErrorTip
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            row._asaStoppedWithNoContent
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "ai-im750-user-stop-tip",
                                                                    attrs: {
                                                                      role:
                                                                        "status"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "aiStudyBuddy.userStoppedNoContentTip"
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            row.agentRes
                                                              ? _vm._l(
                                                                  row.agentResParts,
                                                                  function(
                                                                    part,
                                                                    pi
                                                                  ) {
                                                                    return _c(
                                                                      "div",
                                                                      {
                                                                        key:
                                                                          String(
                                                                            row.aiDialogueChatRecordId
                                                                          ) +
                                                                          "-ar-" +
                                                                          pi,
                                                                        staticClass:
                                                                          "ai-agent-res-part"
                                                                      },
                                                                      [
                                                                        part.type ===
                                                                        "text"
                                                                          ? _c(
                                                                              "ai-streaming-text",
                                                                              {
                                                                                attrs: {
                                                                                  text:
                                                                                    part.text !=
                                                                                    null
                                                                                      ? String(
                                                                                          part.text
                                                                                        )
                                                                                      : "",
                                                                                  streaming: _vm.agentResStreamLive(
                                                                                    row
                                                                                  ),
                                                                                  "typing-dots-active": _vm.agentResPartShowsStreamTypingDots(
                                                                                    row,
                                                                                    part,
                                                                                    pi
                                                                                  )
                                                                                },
                                                                                on: {
                                                                                  "stream-tick":
                                                                                    _vm.scrollAiChatToBottomStream
                                                                                }
                                                                              }
                                                                            )
                                                                          : part.type ===
                                                                            "cards"
                                                                          ? _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "ai-contest-cards-wrap"
                                                                              },
                                                                              _vm._l(
                                                                                part.cards,
                                                                                function(
                                                                                  card,
                                                                                  ci
                                                                                ) {
                                                                                  return _c(
                                                                                    "article",
                                                                                    {
                                                                                      key:
                                                                                        (card.contestId !=
                                                                                        null
                                                                                          ? String(
                                                                                              card.contestId
                                                                                            )
                                                                                          : "c") +
                                                                                        "-" +
                                                                                        ci,
                                                                                      staticClass:
                                                                                        "ai-contest-recommend-card"
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "ai-cr-badge",
                                                                                          class:
                                                                                            "ai-cr-badge--" +
                                                                                            _vm.contestRegistrationBadge(
                                                                                              card
                                                                                            )
                                                                                              .mod
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              _vm.contestRegistrationBadge(
                                                                                                card
                                                                                              )
                                                                                                .text
                                                                                            )
                                                                                          )
                                                                                        ]
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "ai-cr-card-body"
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "ai-cr-row ai-cr-row--challenge"
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "span",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "ai-cr-ico",
                                                                                                  attrs: {
                                                                                                    "aria-hidden":
                                                                                                      "true"
                                                                                                  }
                                                                                                },
                                                                                                [
                                                                                                  _c(
                                                                                                    "img",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "ai-cr-ico-img",
                                                                                                      attrs: {
                                                                                                        src:
                                                                                                          "https://img.webloom.cn/Img/aiCard-zhishu.png",
                                                                                                        alt:
                                                                                                          ""
                                                                                                      }
                                                                                                    }
                                                                                                  )
                                                                                                ]
                                                                                              ),
                                                                                              _vm._v(
                                                                                                " "
                                                                                              ),
                                                                                              _c(
                                                                                                "div",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "ai-cr-row-text"
                                                                                                },
                                                                                                [
                                                                                                  _c(
                                                                                                    "div",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "ai-cr-kv ai-cr-kv--challenge"
                                                                                                    },
                                                                                                    [
                                                                                                      _c(
                                                                                                        "span",
                                                                                                        {
                                                                                                          staticClass:
                                                                                                            "ai-cr-label"
                                                                                                        },
                                                                                                        [
                                                                                                          _vm._v(
                                                                                                            _vm._s(
                                                                                                              _vm.$t(
                                                                                                                "aiStudyBuddy.cardActivityName"
                                                                                                              )
                                                                                                            )
                                                                                                          )
                                                                                                        ]
                                                                                                      ),
                                                                                                      _vm._v(
                                                                                                        " "
                                                                                                      ),
                                                                                                      _c(
                                                                                                        "span",
                                                                                                        {
                                                                                                          staticClass:
                                                                                                            "ai-cr-name"
                                                                                                        },
                                                                                                        [
                                                                                                          _vm._v(
                                                                                                            _vm._s(
                                                                                                              _vm.aiContestCardTitleText(
                                                                                                                card
                                                                                                              )
                                                                                                            )
                                                                                                          )
                                                                                                        ]
                                                                                                      )
                                                                                                    ]
                                                                                                  )
                                                                                                ]
                                                                                              )
                                                                                            ]
                                                                                          ),
                                                                                          _vm._v(
                                                                                            " "
                                                                                          ),
                                                                                          _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "ai-cr-row"
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "span",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "ai-cr-ico",
                                                                                                  attrs: {
                                                                                                    "aria-hidden":
                                                                                                      "true"
                                                                                                  }
                                                                                                },
                                                                                                [
                                                                                                  _c(
                                                                                                    "img",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "ai-cr-ico-img",
                                                                                                      attrs: {
                                                                                                        src:
                                                                                                          "https://img.webloom.cn/Img/aiCard-baomingshijian.png",
                                                                                                        alt:
                                                                                                          ""
                                                                                                      }
                                                                                                    }
                                                                                                  )
                                                                                                ]
                                                                                              ),
                                                                                              _vm._v(
                                                                                                " "
                                                                                              ),
                                                                                              _c(
                                                                                                "div",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "ai-cr-row-text"
                                                                                                },
                                                                                                [
                                                                                                  _c(
                                                                                                    "div",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "ai-cr-kv"
                                                                                                    },
                                                                                                    [
                                                                                                      _c(
                                                                                                        "span",
                                                                                                        {
                                                                                                          staticClass:
                                                                                                            "ai-cr-label"
                                                                                                        },
                                                                                                        [
                                                                                                          _vm._v(
                                                                                                            _vm._s(
                                                                                                              _vm.$t(
                                                                                                                "aiStudyBuddy.cardRegistrationPeriod"
                                                                                                              )
                                                                                                            )
                                                                                                          )
                                                                                                        ]
                                                                                                      ),
                                                                                                      _vm._v(
                                                                                                        " "
                                                                                                      ),
                                                                                                      _c(
                                                                                                        "span",
                                                                                                        {
                                                                                                          staticClass:
                                                                                                            "ai-cr-value"
                                                                                                        },
                                                                                                        [
                                                                                                          _vm._v(
                                                                                                            _vm._s(
                                                                                                              _vm.formatContestEnterRange(
                                                                                                                card
                                                                                                              )
                                                                                                            )
                                                                                                          )
                                                                                                        ]
                                                                                                      )
                                                                                                    ]
                                                                                                  )
                                                                                                ]
                                                                                              )
                                                                                            ]
                                                                                          ),
                                                                                          _vm._v(
                                                                                            " "
                                                                                          ),
                                                                                          _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "ai-cr-row"
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "span",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "ai-cr-ico",
                                                                                                  attrs: {
                                                                                                    "aria-hidden":
                                                                                                      "true"
                                                                                                  }
                                                                                                },
                                                                                                [
                                                                                                  _c(
                                                                                                    "img",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "ai-cr-ico-img",
                                                                                                      attrs: {
                                                                                                        src:
                                                                                                          "https://img.webloom.cn/Img/aiCard-baomingtiaojian.png",
                                                                                                        alt:
                                                                                                          ""
                                                                                                      }
                                                                                                    }
                                                                                                  )
                                                                                                ]
                                                                                              ),
                                                                                              _vm._v(
                                                                                                " "
                                                                                              ),
                                                                                              _c(
                                                                                                "div",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "ai-cr-row-text"
                                                                                                },
                                                                                                [
                                                                                                  _c(
                                                                                                    "div",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "ai-cr-kv"
                                                                                                    },
                                                                                                    [
                                                                                                      _c(
                                                                                                        "span",
                                                                                                        {
                                                                                                          staticClass:
                                                                                                            "ai-cr-label"
                                                                                                        },
                                                                                                        [
                                                                                                          _vm._v(
                                                                                                            _vm._s(
                                                                                                              _vm.$t(
                                                                                                                "aiStudyBuddy.cardEligibility"
                                                                                                              )
                                                                                                            )
                                                                                                          )
                                                                                                        ]
                                                                                                      ),
                                                                                                      _vm._v(
                                                                                                        " "
                                                                                                      ),
                                                                                                      _c(
                                                                                                        "span",
                                                                                                        {
                                                                                                          staticClass:
                                                                                                            "ai-cr-value"
                                                                                                        },
                                                                                                        [
                                                                                                          _vm._v(
                                                                                                            _vm._s(
                                                                                                              _vm.formatContestGradeRange(
                                                                                                                card
                                                                                                              )
                                                                                                            )
                                                                                                          )
                                                                                                        ]
                                                                                                      )
                                                                                                    ]
                                                                                                  )
                                                                                                ]
                                                                                              )
                                                                                            ]
                                                                                          ),
                                                                                          _vm._v(
                                                                                            " "
                                                                                          ),
                                                                                          _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "ai-cr-row"
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "span",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "ai-cr-ico",
                                                                                                  attrs: {
                                                                                                    "aria-hidden":
                                                                                                      "true"
                                                                                                  }
                                                                                                },
                                                                                                [
                                                                                                  _c(
                                                                                                    "img",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "ai-cr-ico-img",
                                                                                                      attrs: {
                                                                                                        src:
                                                                                                          "https://img.webloom.cn/Img/aiCard-tuijian.png",
                                                                                                        alt:
                                                                                                          ""
                                                                                                      }
                                                                                                    }
                                                                                                  )
                                                                                                ]
                                                                                              ),
                                                                                              _vm._v(
                                                                                                " "
                                                                                              ),
                                                                                              _c(
                                                                                                "div",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "ai-cr-row-text"
                                                                                                },
                                                                                                [
                                                                                                  _c(
                                                                                                    "div",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "ai-cr-kv ai-cr-kv--stars"
                                                                                                    },
                                                                                                    [
                                                                                                      _c(
                                                                                                        "span",
                                                                                                        {
                                                                                                          staticClass:
                                                                                                            "ai-cr-label"
                                                                                                        },
                                                                                                        [
                                                                                                          _vm._v(
                                                                                                            _vm._s(
                                                                                                              _vm.$t(
                                                                                                                "aiStudyBuddy.cardRecommendationLevel"
                                                                                                              )
                                                                                                            )
                                                                                                          )
                                                                                                        ]
                                                                                                      ),
                                                                                                      _vm._v(
                                                                                                        " "
                                                                                                      ),
                                                                                                      _c(
                                                                                                        "span",
                                                                                                        {
                                                                                                          staticClass:
                                                                                                            "ai-cr-stars",
                                                                                                          attrs: {
                                                                                                            "aria-label": _vm.aiContestRatingAria(
                                                                                                              card
                                                                                                            )
                                                                                                          }
                                                                                                        },
                                                                                                        _vm._l(
                                                                                                          5,
                                                                                                          function(
                                                                                                            n
                                                                                                          ) {
                                                                                                            return _c(
                                                                                                              "div",
                                                                                                              {
                                                                                                                key: n,
                                                                                                                staticClass:
                                                                                                                  "ai-cr-star-item"
                                                                                                              },
                                                                                                              [
                                                                                                                _c(
                                                                                                                  "img",
                                                                                                                  {
                                                                                                                    attrs: {
                                                                                                                      src:
                                                                                                                        n <=
                                                                                                                        _vm.normalizeContestRating(
                                                                                                                          card.rating
                                                                                                                        )
                                                                                                                          ? _vm
                                                                                                                              .aiContestCardStarImgs
                                                                                                                              .on
                                                                                                                          : _vm
                                                                                                                              .aiContestCardStarImgs
                                                                                                                              .off,
                                                                                                                      alt:
                                                                                                                        ""
                                                                                                                    }
                                                                                                                  }
                                                                                                                )
                                                                                                              ]
                                                                                                            )
                                                                                                          }
                                                                                                        ),
                                                                                                        0
                                                                                                      )
                                                                                                    ]
                                                                                                  )
                                                                                                ]
                                                                                              )
                                                                                            ]
                                                                                          ),
                                                                                          _vm._v(
                                                                                            " "
                                                                                          ),
                                                                                          _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "ai-cr-row ai-cr-row--last"
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "span",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "ai-cr-ico",
                                                                                                  attrs: {
                                                                                                    "aria-hidden":
                                                                                                      "true"
                                                                                                  }
                                                                                                },
                                                                                                [
                                                                                                  _c(
                                                                                                    "img",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "ai-cr-ico-img",
                                                                                                      attrs: {
                                                                                                        src:
                                                                                                          "https://img.webloom.cn/Img/aiCard-liyou.png",
                                                                                                        alt:
                                                                                                          ""
                                                                                                      }
                                                                                                    }
                                                                                                  )
                                                                                                ]
                                                                                              ),
                                                                                              _vm._v(
                                                                                                " "
                                                                                              ),
                                                                                              _c(
                                                                                                "div",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "ai-cr-row-text"
                                                                                                },
                                                                                                [
                                                                                                  _c(
                                                                                                    "div",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "ai-cr-kv ai-cr-kv--reason"
                                                                                                    },
                                                                                                    [
                                                                                                      _c(
                                                                                                        "span",
                                                                                                        {
                                                                                                          staticClass:
                                                                                                            "ai-cr-label"
                                                                                                        },
                                                                                                        [
                                                                                                          _vm._v(
                                                                                                            _vm._s(
                                                                                                              _vm.$t(
                                                                                                                "aiStudyBuddy.cardWhyRecommended"
                                                                                                              )
                                                                                                            )
                                                                                                          )
                                                                                                        ]
                                                                                                      ),
                                                                                                      _vm._v(
                                                                                                        " "
                                                                                                      ),
                                                                                                      _c(
                                                                                                        "p",
                                                                                                        {
                                                                                                          staticClass:
                                                                                                            "ai-cr-reason"
                                                                                                        },
                                                                                                        [
                                                                                                          _vm._v(
                                                                                                            _vm._s(
                                                                                                              card.reason ||
                                                                                                                "—"
                                                                                                            )
                                                                                                          )
                                                                                                        ]
                                                                                                      )
                                                                                                    ]
                                                                                                  )
                                                                                                ]
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        ]
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "button",
                                                                                        {
                                                                                          staticClass:
                                                                                            "ai-cr-detail-btn",
                                                                                          attrs: {
                                                                                            type:
                                                                                              "button"
                                                                                          },
                                                                                          on: {
                                                                                            click: function(
                                                                                              $event
                                                                                            ) {
                                                                                              return _vm.openAiContestDetailFromCard(
                                                                                                card
                                                                                              )
                                                                                            }
                                                                                          }
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              _vm.$t(
                                                                                                "aiStudyBuddy.viewActivityDetails"
                                                                                              )
                                                                                            )
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                }
                                                                              ),
                                                                              0
                                                                            )
                                                                          : part.type ===
                                                                            "topicFence"
                                                                          ? _c(
                                                                              "ai-assistant-topic-fence",
                                                                              {
                                                                                attrs: {
                                                                                  "topic-tree":
                                                                                    part.topicTree,
                                                                                  "topic-list":
                                                                                    part.topicList,
                                                                                  "panel-compact":
                                                                                    _vm.aiAssistantCompact
                                                                                }
                                                                              }
                                                                            )
                                                                          : _vm._e()
                                                                      ],
                                                                      1
                                                                    )
                                                                  }
                                                                )
                                                              : _vm._e()
                                                          ],
                                                          2
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              }
                                            )
                                          : _vm._e()
                                      ]
                                    : _vm.selectedHistoryItem &&
                                      !_vm.selectedHistoryItem.fromServer
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "ai-msg ai-msg--user"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.selectedHistoryItem.text
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "ai-msg ai-msg--assistant"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "aiStudyBuddy.localHistoryPlaceholder"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    : _vm._e()
                                ]
                              : !_vm.aiChatHistory.length
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "ai-msg ai-msg--assistant ai-history-main-hint"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("aiStudyBuddy.historyEmpty")
                                      )
                                    )
                                  ]
                                )
                              : _c(
                                  "p",
                                  {
                                    staticClass:
                                      "ai-msg ai-msg--assistant ai-history-main-hint"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("aiStudyBuddy.historySelectHint")
                                      )
                                    )
                                  ]
                                )
                          ]
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "ai-assistant-footer" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.showAiQuickChips &&
                              _vm.aiSidebarTab === "newChat",
                            expression:
                              "showAiQuickChips && aiSidebarTab === 'newChat'"
                          }
                        ],
                        staticClass: "ai-prompts-wrap",
                        class: {
                          "ai-prompts-wrap--compact": _vm.aiAssistantCompact
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "ai-quick-prompts" },
                          _vm._l(_vm.aiQuickChips, function(chip) {
                            return _c(
                              "button",
                              {
                                key: "ai-kp-" + chip.poolIndex,
                                staticClass: "ai-chip",
                                attrs: {
                                  type: "button",
                                  disabled: _vm.aiAssistantTextareaDisabled
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.setAiInput(chip.value)
                                  }
                                }
                              },
                              [
                                _c("span", { staticClass: "ai-chip-title" }, [
                                  _vm._v(_vm._s(_vm.chipTitleDisplay(chip)))
                                ]),
                                _vm._v(" "),
                                _vm.chipHintDisplay(chip)
                                  ? _c(
                                      "span",
                                      { staticClass: "ai-chip-hint" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.chipHintDisplay(chip))
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          }),
                          0
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "ai-input-wrap",
                        class: {
                          "ai-input-wrap--locked":
                            _vm.aiAssistantTextareaDisabled
                        }
                      },
                      [
                        _c("div", { staticClass: "ai-input-gradient" }, [
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.aiInputText,
                                expression: "aiInputText"
                              }
                            ],
                            ref: "aiInputField",
                            staticClass: "ai-input-field",
                            attrs: {
                              rows: "1",
                              maxlength: "5000",
                              placeholder: _vm.aiInputPlaceholder,
                              disabled: _vm.aiAssistantTextareaDisabled
                            },
                            domProps: { value: _vm.aiInputText },
                            on: {
                              input: [
                                function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.aiInputText = $event.target.value
                                },
                                _vm.adjustAiTextareaHeight
                              ],
                              keydown: _vm.onAiInputKeydown
                            }
                          }),
                          _vm._v(" "),
                          !_vm.aiAssistantCompact
                            ? _c("div", { staticClass: "ai-send-row" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "ai-send-btn",
                                    attrs: {
                                      type: "button",
                                      disabled:
                                        _vm.aiAssistantSendButtonDisabled,
                                      "aria-label":
                                        _vm.aiAssistantSendButtonAria
                                    },
                                    on: { click: _vm.onAiSendOrStop }
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src:
                                          _vm.aiAssistantWaitingImReply ||
                                          _vm.aiSendLoading
                                            ? "https://img.webloom.cn/Img/aiSendIng.webp"
                                            : "https://img.webloom.cn/Img/aiSend.webp",
                                        alt: ""
                                      }
                                    })
                                  ]
                                )
                              ])
                            : _vm._e()
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm.aiAssistantCompact
                      ? _c("div", { staticClass: "ai-compact-footer-bar" }, [
                          _c("p", { staticClass: "ai-disclaimer" }, [
                            _vm._v(_vm._s(_vm.$t("aiStudyBuddy.disclaimer")))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "ai-send-row" }, [
                            _c(
                              "button",
                              {
                                staticClass: "ai-send-btn",
                                attrs: {
                                  type: "button",
                                  disabled: _vm.aiAssistantSendButtonDisabled,
                                  "aria-label": _vm.aiAssistantSendButtonAria
                                },
                                on: { click: _vm.onAiSendOrStop }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src:
                                      _vm.aiAssistantWaitingImReply ||
                                      _vm.aiSendLoading
                                        ? "https://img.webloom.cn/Img/aiSendIng.webp"
                                        : "https://img.webloom.cn/Img/aiSend.webp",
                                    alt: ""
                                  }
                                })
                              ]
                            )
                          ])
                        ])
                      : _c("p", { staticClass: "ai-disclaimer" }, [
                          _vm._v(_vm._s(_vm.$t("aiStudyBuddy.disclaimer")))
                        ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "ai-assistant-shrink-btn",
                attrs: {
                  type: "button",
                  "aria-label": _vm.aiAssistantCompact
                    ? _vm.$t("aiStudyBuddy.ariaExpandFull")
                    : _vm.$t("aiStudyBuddy.ariaShrinkWindow")
                },
                on: { click: _vm.onAiAssistantShrink }
              },
              [
                _c("img", {
                  staticClass: "ai-assistant-shrink-btn-icon",
                  class: {
                    "ai-assistant-shrink-btn-icon--expanded":
                      _vm.aiAssistantCompact
                  },
                  attrs: {
                    src:
                      "https://img.webloom.cn/Img/%E6%94%B6%E8%B5%B7%20(2)%402x.webp",
                    alt: "",
                    width: "14",
                    height: "10"
                  }
                })
              ]
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-7fded991", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-7fded991","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/public/header-box.vue
// module id = null
// module chunks = 